import {
    ColorPaletteIcon,
    ComplaintIcon,
    FileSearchIcon,
    NotesIcon,
    UserLicenseIcon
} from "@/components/icons";
import { Bell, BriefcaseBusiness, IdCard, User2 } from "lucide-react";
import { ReactNode } from "react";
// import { 
//     ContentType, 
//     Action, 
//     getPermission 
// } from "@/guards/access_guard/permissions";

export type TMenuLink = {
    label: string
    path: string
    pattern: RegExp
    icon?: ReactNode,
    permissions: string[],
    subMenus?: {
        label: string
        path: string
        icon?: ReactNode,
        permissions: string[],
    }[]
}

export type TMenuGroups = {
    heading: string
    menus: TMenuLink[]
}

export const basicMenus: TMenuLink[] = [
    {
        label: "Overview",
        path: "/dashboard",
        pattern: new RegExp("^/dashboard$"),
        icon: <ColorPaletteIcon className="size-5" />,
        permissions: []
    },
    {
        label: "Applications",
        path: "/applications/licences",
        pattern: new RegExp("^/applications?"),
        icon: <NotesIcon className="size-5" />,
        permissions: [],
        
    },
    {
        label: "Inspections",
        path: "/inspections",
        pattern: new RegExp("^/inspections*"),
        icon: <FileSearchIcon className="size-5" />,
        permissions: [],
    },
    {
        label: "Complaints",
        path: "/complaints",
        pattern: new RegExp("^/complaints*"),
        icon: <ComplaintIcon className="size-5" />,
        permissions: []
    },
    { 
        label: "Licence", 
        path: "/licences",
        pattern: new RegExp("^/licences*"),
        icon: <UserLicenseIcon className="size-5" />,
        permissions: [],
    }
]

export const basicsettingsMenus: TMenuLink[] = [
    { 
        label: "Profile", 
        path: "/settings/",
        // `/settings/` renders Profile as its index route - matching the old
        // "^/settings/profile*" meant this tab was never highlighted.
        pattern: new RegExp("^/settings/?$"),
        icon: <User2 className="size-5" />,
        permissions: [],
    },
    { 
        label: "Identification", 
        path: "/settings/identification", 
        pattern: new RegExp("^/settings/identification*"),
        icon: <IdCard className="size-5" />,
        permissions: [],
    },
    { 
        label: "Business", 
        path: "/settings/business", 
        pattern: new RegExp("^/settings/business*"),
        icon: <BriefcaseBusiness className="size-5" />,
        permissions: [],
    },
    { 
        label: "Notification", 
        path: "/settings/notification", 
        pattern: new RegExp("^/settings/notification*"),
        icon: <Bell  className="size-5" />,
        permissions: [],
    },
]







export const sidebarMenu: TMenuGroups[] = [
    {
        heading: "Main navigations",
        menus: basicMenus
    }
]



export const settingsMenus: TMenuGroups[] = [
    {
        heading: "Settings Menus",
        menus: basicsettingsMenus
    }
]